<section class="hvac-highlights">
    <div class="hvac-highlights-highlight hvac-highlights-highlight-wide">
            <hvac-highlight-section [data]="data" [fullWidth]="true"></hvac-highlight-section>
    </div>
</section>
